export default __webpack_public_path__ + "static/media/logoPrimary.cb57539e.svg";